import Cookies from 'js-cookie'

export function get (name) {
  return Cookies.get(name)
}

export function set (name, value) {
  return Cookies.set(name, value)
}

export function remove (name) {
  return Cookies.remove(name)
}
